<template>
  <div class="target-drawer">
    <!-- iframe模式：无标题栏 -->
    <template v-if="mode === 'target'">
      <div class="iframe-wrapper">
        <!-- <button class="iframe-close-btn" @click="$emit('close')">
          <i class="el-icon-close"></i>
        </button> -->
        <iframe :src="iframeUrl" class="target-iframe" frameborder="0" @load="$emit('iframe-load', $event)"></iframe>
      </div>
    </template>

    <!-- 预警清单模式 -->
    <template v-else-if="mode === 'warning'">
      <!-- <div class="drawer-header">
        <h2>{{ drawerTitle }}</h2>
        <button class="drawer-close" @click="$emit('close')">
          <i class="el-icon-close"></i>
        </button>
      </div> -->
      <div class="warning-list-detail">
        <p class="drawer-desc mb-4">预警报警清单，共 {{ warnings.length }} 项待处理</p>
        <div class="warn-card" v-for="w in warnings" :key="w.id" :class="'warn-' + w.levelColor">
          <div class="warn-card-header">
            <div class="warn-card-left">
              <span class="warn-icon" :class="'warn-icon-' + w.levelColor">
                <i :class="w.levelColor === 'red' ? 'el-icon-warning-outline' : 'el-icon-warning'"></i>
              </span>
              <span class="warn-card-title">{{ w.title }}</span>
            </div>
            <span class="warn-tag" :class="'warn-tag-' + w.levelColor">{{ w.level }}</span>
          </div>
          <div class="warn-card-body">
            <div class="warn-desc">{{ w.desc }}</div>
            <div class="warn-detail-grid">
              <div><span class="warn-label">持续时间：</span>{{ w.duration }}</div>
              <div><span class="warn-label">指标：</span>{{ w.metric }}</div>
              <div><span class="warn-label">影响：</span><span class="text-danger">{{ w.impact }}</span></div>
              <div><span class="warn-label">建议：</span>{{ w.suggestion }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- SKILLS 模式 -->
    <template v-else-if="mode === 'skills'">
      <!-- <div class="drawer-header">
        <h2>{{ drawerTitle }}</h2>
        <button class="drawer-close" @click="$emit('close')">
          <i class="el-icon-close"></i>
        </button>
      </div> -->
      <div class="skills-detail">
        <p class="drawer-desc mb-4">{{ skillsDesc }}</p>
        <div class="skills-list">
          <div class="skill-item" v-for="sk in skillsList" :key="sk.id" @click="toggleSkill(sk.id)">
            <div class="skill-header">
              <span class="skill-icon" :style="{ background: sk.color + '18', color: sk.color }">
                <i :class="sk.icon"></i>
              </span>
              <div class="skill-info">
                <span class="skill-name">{{ sk.name }}</span>
                <span class="skill-scene">{{ sk.scene.substring(0, 40) }}...</span>
              </div>
              <i class="el-icon-arrow-right skill-arrow" :class="{ expanded: expandedSkills[sk.id] }"></i>
            </div>
            <div class="skill-body" v-show="expandedSkills[sk.id]">
              <div class="skill-desc">{{ sk.desc }}</div>
              <div class="skill-scene-full"><span class="skill-label">适用场景：</span>{{ sk.scene }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- 方法论模式 -->
    <template v-else-if="mode === 'methodology'">
      <!-- <div class="drawer-header">
        <h2>{{ drawerTitle }}</h2>
        <button class="drawer-close" @click="$emit('close')">
          <i class="el-icon-close"></i>
        </button>
      </div> -->
      <div class="methodology-detail">
        <div class="methodology-layout">
          <div class="m-left">
            <div
              class="m-scene-item"
              v-for="sc in METHODOLOGY_DATA"
              :key="sc.id"
              :class="{ active: activeMethodology === sc.id }"
              :style="{ borderColor: activeMethodology === sc.id ? sc.color : 'transparent', background: activeMethodology === sc.id ? sc.color + '12' : '' }"
              @click="activeMethodology = sc.id"
            >
              <span class="m-scene-icon" :style="{ color: sc.color }"><i :class="sc.icon"></i></span>
              <span class="m-scene-name">{{ sc.name }}</span>
            </div>
          </div>
          <div class="m-right">
            <div class="m-method-item" v-for="m in currentMethods" :key="m.name" @click="toggleMethod(m.name)">
              <div class="m-method-header">
                <span class="m-arrow" :class="{ expanded: expandedMethods[m.name] }"><i class="el-icon-arrow-right"></i></span>
                <span class="m-method-name">{{ m.name }}</span>
              </div>
              <div class="m-method-body" v-show="expandedMethods[m.name]">
                <p>{{ m.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { BIGDATA_HOST } from './bigdataPath'

export default {
  name: 'TargetDrawer',
  props: {
    mode: { type: String, default: 'target' },
    initialTab: { type: String, default: 'library' },
    skillAnalysisData: { type: Object, default: null }
  },
  data() {
    return {
      warnings: [
        { id: 1, title: '库存周转预警', level: '紧急', levelColor: 'red', dept: '仓储部', desc: '库存周转天数 42天，超目标40%', duration: '已持续 2 个月', metric: '目标≤30天，实际42天', impact: '预计增加仓储成本 68 万元/月', suggestion: '建议启动库存清理计划' },
        { id: 2, title: '成本异常波动', level: '关注', levelColor: 'amber', dept: '采购部', desc: '原材料成本环比上涨 3.2%', duration: '持续 1 个月', metric: '预算涨幅≤1.5%', impact: '预计影响毛利约 215 万元', suggestion: '建议重新谈判价格' },
        { id: 3, title: '交付延期风险', level: '关注', levelColor: 'amber', dept: '供应链部', desc: '本月准时交付率 67%', duration: '本月', metric: '目标≥98%', impact: '涉及订单金额约 860 万元', suggestion: '排查产能瓶颈' },
        { id: 4, title: '设备故障率上升', level: '关注', levelColor: 'amber', dept: '设备部', desc: '本月设备故障率 8.5%', duration: '本月', metric: '警戒线≤5%', impact: '预计影响产能约 15%', suggestion: '安排预防性维护' },
        { id: 5, title: '应收账款逾期', level: '紧急', levelColor: 'red', dept: '财务部', desc: '逾期应收账款 1,280 万元', duration: '已持续 3 个月', metric: '逾期率23%', impact: '影响现金流约 1,280 万元', suggestion: '启动专项催收' }
      ],
      expandedSkills: {},
      expandedMethods: {},
      activeMethodology: 'prod',
      SKILLS_DATA: [
        { id: 'anomaly', name: '数据异常检测', icon: 'fa fa-search', color: '#4a5ff3', desc: '自动识别指标异常波动与离群点，支持多维下钻分析，快速定位异常维度', scene: '适用于KPI监控、经营预警、质量异常发现等场景，帮助数据分析师快速发现数据异常' },
        { id: 'rootcause', name: '根因归因分析', icon: 'fa fa-sitemap', color: '#52c41a', desc: '追溯问题根因与影响链路，基于相关性分析和贡献度计算，定位核心影响因素', scene: '适用于收入下降分析、成本异常归因、OEE波动诊断等场景，辅助决策者快速定位根因' },
        { id: 'trend', name: '趋势预测', icon: 'fa fa-line-chart', color: '#ff7d00', desc: '基于历史数据预测未来趋势，支持多种时间序列模型，提供置信区间评估', scene: '适用于销售预测、库存需求预测、产能规划等场景，帮助企业提前布局' },
        { id: 'compare', name: '同环比分析', icon: 'fa fa-exchange', color: '#a855f7', desc: '对比不同周期数据变化，自动计算同比/环比增长率，识别季节性波动与周期规律', scene: '适用于经营分析报告、财务数据分析、市场表现评估等场景，快速了解业务变化' },
        { id: 'target', name: '单达成评估', icon: 'fa fa-bullseye', color: '#06b6d4', desc: '评估KPI达成情况，计算完成率、偏差率，支持按时间维度下钻查看达成趋势', scene: '适用于目标管理、绩效考核、战略落地跟踪等场景，帮助企业掌控目标进度' },
        { id: 'structure', name: '结构分析', icon: 'fa fa-pie-chart', color: '#ef4444', desc: '分析数据构成比例，拆解各组成部分的贡献度与变化率，识别结构性问题', scene: '适用于收入结构分析、成本构成拆解、市场份额分析等场景，洞察业务结构变化' },
        { id: 'distribution', name: '分布分析', icon: 'fa fa-bar-chart', color: '#6366f1', desc: '分析数据分布特征，识别集中趋势与离散程度，发现数据分布异常', scene: '适用于客户分层分析、质量分布分析、价格带分析等场景，了解数据全貌' },
        { id: 'correlation', name: '相关性分析', icon: 'fa fa-circle-o', color: '#ec4899', desc: '分析变量之间的相关关系，计算相关系数，识别强关联与共线性问题', scene: '适用于指标关联分析、投入产出分析、市场因素分析等场景，发现隐藏的业务关系' }
      ],
      METHODOLOGY_DATA: [
        { id: 'prod', name: '生产场景', icon: 'fa fa-industry', color: '#4a5ff3', methods: [
          { name: 'DMAIC（六西格玛）', desc: '通过定义-测量-分析-改进-控制，系统暴露生产过程中的变异、缺陷、不良率、不稳定性根源' },
          { name: 'OEE损失分析', desc: '暴露设备综合效率低下背后的三大损失：时间开动损失、性能损失、质量损失' },
          { name: '价值流图（VSM）', desc: '暴露生产流程中的等待、库存、冗余搬运、信息流阻塞等浪费环节' }
        ] },
        { id: 'fin', name: '财务场景', icon: 'fa fa-money', color: '#52c41a', methods: [
          { name: '杜邦分析（DuPont）', desc: '暴露净资产收益率变动背后的驱动因素：销售净利率、资产周转率、权益乘数' },
          { name: '趋势分析与同比/环比对比', desc: '暴露收入、成本、利润、现金流等关键指标的异常波动' },
          { name: 'Z-score财务预警模型', desc: '暴露企业破产风险及综合财务健康状况' }
        ] },
        { id: 'ops', name: '运营场景', icon: 'fa fa-bar-chart', color: '#ff7d00', methods: [
          { name: '平衡计分卡战略偏差分析', desc: '暴露战略执行中的失衡：财务指标达成但客户满意度下降' },
          { name: '流程瓶颈分析（约束理论TOC）', desc: '暴露整个运营链条中最制约产出的瓶颈环节' },
          { name: 'KPI红黄绿灯监控', desc: '暴露实际值与目标值、行业标杆值的差距' }
        ] },
        { id: 'rd', name: '研发场景', icon: 'fa fa-flask', color: '#a855f7', methods: [
          { name: '集成产品开发阶段评审回溯', desc: '暴露研发项目各阶段的决策质量、需求变更频率' },
          { name: '质量功能展开失配分析', desc: '暴露客户需求与技术特性之间的转化偏差' },
          { name: '研发项目挣值管理', desc: '暴露项目进度与成本的实际绩效' }
        ] },
        { id: 'admin', name: '行政场景', icon: 'el-icon-s-custom', color: '#06b6d4', methods: [
          { name: '工业工程工作抽样', desc: '暴露行政人员时间利用率问题' },
          { name: '5W2H + 鱼骨图', desc: '暴露行政流程中的重复审批、文件流转延迟' }
        ] },
        { id: 'safety', name: '安全场景', icon: 'el-icon-warning', color: '#ef4444', methods: [
          { name: 'LEC法作业条件危险性评价', desc: '暴露各作业环节的风险等级' },
          { name: '海因里希法则事故金字塔分析', desc: '暴露轻微事故、未遂事件背后的系统安全缺陷' }
        ] }
      ]
    }
  },
  computed: {
    drawerTitle() {
      if (this.mode === 'skills' && this.skillAnalysisData && this.skillAnalysisData.title) {
        return this.skillAnalysisData.title
      }
      const titles = { warning: '预警报警清单', skills: '分析 SKILLS', methodology: '分析方法论', target: '目标体系看板' }
      return titles[this.mode] || '目标体系看板'
    },
    skillsDesc() {
      if (this.skillAnalysisData && this.skillAnalysisData.description) {
        return this.skillAnalysisData.description
      }
      return '沉淀的数据分析技能，覆盖多业务域分析场景'
    },
    skillsList() {
      if (this.skillAnalysisData && this.skillAnalysisData.skills) {
        const icons = ['fa fa-search', 'fa fa-sitemap', 'fa fa-line-chart', 'fa fa-exchange', 'fa fa-bullseye', 'fa fa-pie-chart', 'fa fa-bar-chart', 'fa fa-circle-o']
        const colors = ['#4a5ff3', '#52c41a', '#ff7d00', '#a855f7', '#06b6d4', '#ef4444', '#6366f1', '#ec4899']
        return this.skillAnalysisData.skills.map((sk, i) => ({
          id: sk.title,
          name: sk.title,
          icon: icons[i] || 'fa fa-star',
          color: colors[i] || '#4a5ff3',
          desc: sk.skillDescription,
          scene: sk.applicableScenarios
        }))
      }
      return this.SKILLS_DATA
    },
    iframeUrl() {
      // const isProd = process.env.VUE_APP_CURRENTMODE === 'prod'
      const base = BIGDATA_HOST + '/cdh-public-target-system'
      const tab = this.initialTab
      if (tab) {
        return `${base}?tab=${tab}`
      }
      return base
    },
    currentMethods() {
      const scene = this.METHODOLOGY_DATA.find(s => s.id === this.activeMethodology)
      return scene ? scene.methods : []
    }
  },
  methods: {
    toggleSkill(id) {
      this.$set(this.expandedSkills, id, !this.expandedSkills[id])
    },
    toggleMethod(name) {
      this.$set(this.expandedMethods, name, !this.expandedMethods[name])
    }
  }
}
</script>

<style lang="scss" scoped>
.target-drawer {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
  background: #fff;
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;

  h2 { font-size: 17px; font-weight: 600; color: #1a1a2e; margin: 0; }
  .drawer-close {
    width: 32px; height: 32px; border-radius: 8px;
    display: flex; align-items: center; justify-content: center;
    border: none; background: transparent; color: #999; cursor: pointer;
    transition: all 0.2s;
    &:hover { background: #f5f5f5; color: #333; }
  }
}

/* iframe 模式 - 无标题，仅浮层关闭按钮 */
.iframe-wrapper {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;

  .iframe-close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: none;
    background: rgba(255,255,255,0.9);
    color: #999;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    z-index: 10;
    box-shadow: 0 2px 6px rgba(0,0,0,0.08);

    &:hover {
      background: #fff;
      color: #333;
    }

    i { font-size: 16px; }
  }

  .target-iframe {
    width: 100%;
    flex: 1;
    border: none;
  }
}

.drawer-desc {
  padding: 12px 20px 8px;
  font-size: 13px;
  color: #888;
  line-height: 1.6;
  flex-shrink: 0;
}

.mb-4 { margin-bottom: 16px; }

// Warning list
.warning-list-detail {
  padding: 16px 20px;
  overflow-y: auto;
  flex: 1;
}

.warn-card {
  border: 1px solid;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 12px;

  &.warn-red { border-color: #fecaca; background: #fef2f2; }
  &.warn-amber { border-color: #fde68a; background: #fffbeb; }

  .warn-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: #fff;
    border-bottom: 1px solid #f0f0f0;

    .warn-card-left {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .warn-icon { font-size: 14px; }
    .warn-icon-red { color: #ef4444; }
    .warn-icon-amber { color: #f59e0b; }

    .warn-card-title { font-size: 14px; font-weight: 600; color: #1e293b; }

    .warn-tag {
      font-size: 11px;
      font-weight: 500;
      padding: 2px 10px;
      border-radius: 999px;
      &.warn-tag-red { background: #fef2f2; color: #ef4444; }
      &.warn-tag-amber { background: #fffbeb; color: #d97706; }
    }
  }

  .warn-card-body {
    padding: 12px 16px;
    background: #fff;
    font-size: 12px;

    .warn-desc { color: #666; margin-bottom: 10px; }

    .warn-detail-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 6px 16px;
      color: #666;

      .warn-label { color: #94a3b8; }
    }
  }
}

// Skills
.skills-detail {
  padding: 16px 20px;
  overflow-y: auto;
  flex: 1;
}

.skills-list {
  .skill-item {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 8px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover { border-color: #a5b4fc; }

    .skill-header {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 14px 16px;

      .skill-icon {
        width: 32px; height: 32px;
        display: flex; align-items: center; justify-content: center;
        border-radius: 8px; flex-shrink: 0;
        i { font-size: 14px; }
      }

      .skill-info {
        flex: 1;
        min-width: 0;
        .skill-name { font-size: 14px; font-weight: 600; color: #1e293b; display: block; }
        .skill-scene { font-size: 12px; color: #94a3b8; }
      }

      .skill-arrow {
        color: #94a3b8;
        transition: transform 0.2s;
        &.expanded { transform: rotate(90deg); }
      }
    }

    .skill-body {
      padding: 0 16px 14px;
      border-top: 1px solid #f0f0f0;

      .skill-desc { font-size: 12px; color: #666; line-height: 1.8; margin-top: 10px; }
      .skill-scene-full { font-size: 12px; color: #666; line-height: 1.8; margin-top: 6px; }
      .skill-label { color: #94a3b8; }
    }
  }
}

// Methodology
.methodology-detail {
  padding: 16px 20px;
  overflow-y: auto;
  flex: 1;
  min-height: 400px;
}

.methodology-layout {
  display: flex;
  gap: 16px;
  min-height: 360px;

  .m-left {
    width: 140px;
    flex-shrink: 0;

    .m-scene-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 10px 12px;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.15s;
      border: 2px solid transparent;
      margin-bottom: 4px;

      &.active { font-weight: 600; }

      .m-scene-icon { font-size: 13px; width: 20px; text-align: center; }
      .m-scene-name { font-size: 12px; }
    }
  }

  .m-right {
    flex: 1;
    min-width: 0;

    .m-method-item {
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      margin-bottom: 8px;
      cursor: pointer;
      overflow: hidden;

      &:hover { border-color: #a5b4fc; }

      .m-method-header {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px;

        .m-arrow {
          color: #94a3b8;
          transition: transform 0.2s;
          font-size: 12px;
          &.expanded { transform: rotate(90deg); }
        }
        .m-method-name { font-size: 13px; font-weight: 500; color: #1e293b; }
      }

      .m-method-body {
        padding: 0 12px 12px;
        border-top: 1px solid #f0f0f0;
        margin-left: 24px;
        p { font-size: 12px; color: #666; line-height: 1.8; margin: 8px 0 0; }
      }
    }
  }
}

.text-danger { color: #ef4444; }
</style>
